export default __webpack_public_path__ + "static/media/instagram_ico.1c2974f9.svg";